<template>
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-dark navbar-main bg-dark">
            <a class="navbar-brand" href="#">GrandShipper</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse">
                <ul class="navbar-nav mr-auto">
                    <router-link to="/" tag="li" class="nav-item" exact>
                        <a class="nav-link"><i class="fas fa-tachometer-alt"></i> Dashboard</a>
                    </router-link>
                    <router-link to="/shipments" tag="li" class="nav-item" exact>
                        <a class="nav-link"><i class="fas fa-truck"></i> Shipments</a>
                    </router-link>
                    <router-link to="/orders" tag="li" class="nav-item" exact>
                        <a class="nav-link"> <i class="fas fa-shopping-cart"></i> Orders</a>
                    </router-link>
                    <router-link to="/shipping-addresses" tag="li" class="nav-item" exact>
                        <a class="nav-link"><i class="fas fa-address-book"></i> Shipping Addresses</a>
                    </router-link>
                </ul>
            </div>

            <!-- Right Side Of Navbar -->
            <ul class="navbar-nav ml-auto">
                <router-link to="/enterprise-features" tag="li" class="nav-item" exact>
                    <a class="nav-link"><i class="fas fa-cog"></i> Enterprise Features</a>
                </router-link>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-user"></i> {{ user.name }} <span class="caret"></span>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="#" @click.prevent="logout">
                            Logout
                        </a>
                    </div>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {

        data () {
            return {
                user: {}
            };
        },
        created() {
            let self = this;
            axios.get('/users?ajax=true')
                .then(function (response) {
                    self.user =  response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        methods: {
            logout: function() {
                console.log("LOGOUT!!!!")
                axios.post('/logout')
                    .then(function (response) {
                        localStorage.removeItem('shipper');
                        window.location = '/';
                    })
                    .catch(function (error) {
                        window.location = '/';
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NavigationMenu.vue